
import O1HD, { managers } from "../../../../../../engines/gameEngine";
import lv10012 from "./lv10012";
import view_012, { ViewAnswer012 } from "./view_012";

const { ccclass, property } = cc._decorator;
export interface MoveInfo_012 {
    index: number,
    id: string,//唯一标识id
    node: cc.Node,//节点对象
    startPos: cc.Vec3,//初始位置
    oldParent: cc.Node,//原来的父节点
}
@ccclass
export default class view1_012 extends view_012 {

    /** 人1说话节点 */
    @property({ type: cc.Node, displayName: "人1说话节点" })
    ren1SayNode: cc.Node = null;
    /** 人2说话节点 */
    @property({ type: cc.Node, displayName: "人2说话节点" })
    ren2SayNode: cc.Node = null;
    /** 人3说话节点 */
    @property({ type: cc.Node, displayName: "人3说话节点" })
    ren3SayNode: cc.Node = null;
    /** 人4说话节点 */
    @property({ type: cc.Node, displayName: "人4说话节点" })
    ren4SayNode: cc.Node = null;
    /** 选择节点 */
    @property({ type: cc.Node, displayName: "选择节点" })
    endClick: cc.Node = null;
    /** 敲门节点 */
    @property({ type: cc.Node, displayName: "敲门节点" })
    qiaoClick: cc.Node = null;
    /** 特写1节点 */
    @property({ type: cc.Node, displayName: "特写1节点" })
    texie1Node: cc.Node = null;
    /** 特写2节点 */
    @property({ type: cc.Node, displayName: "特写2节点" })
    texie2Node: cc.Node = null;
    /** 特写3节点 */
    @property({ type: cc.Node, displayName: "特写3节点" })
    texie3Node: cc.Node = null;

    isCanNa: boolean[] = [false, false, false];

    readonly answerImgList: string[] = [

    ];//答案图列表

    readonly clickSoundList: string[] = [
        'PB5',
        'A4',
        'PB4',
        '',
        '',
        'C3',
    ];//答案显示后的音效播放

    readonly showChatList: string[] = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
    ];//答案显示后的对话文本
    readonly imgListUrl: string = 'Img/daan/1/'

    readonly showStr: string[] = [
        '消失的脚',
        '符纸卷纸',

        '赤脚',
        '皱巴巴的纸',

        '手机',
        '砂纸',

    ]

    /** 当前移动物品的数量 */
    curMoveObjNum: number = 0;

    /** 当前答对的数量 */
    curBingoNum: number = 0;

    curOpenSay: cc.Node[] = [];

    /** 当前阶段 */
    curStage: number = -1;

    zongBingoNum: number = 0;
    /** 当前说话的节点 */
    curSayNode: cc.Node = null;

    /** 是否播放走路音效 */
    isPlayZouSound: boolean = true;
    async initLevel(bundle: string) {
        super.initLevel(bundle);//初始化所有信息

        //TODO 播放音效
        managers().soundMgr.playMusic("bgm", bundle)
        // await new Promise<void>((resolve, reject) => {
        //     cc.tween(this.node).delay(1).call(() => {
        //         managers().soundMgr.playSound("lv10012/sound/1");
        //         this.showChat('到哪去了，不是约好了一起来餐厅吃饭的吗？')
        //         resolve();
        //     }).start()
        // })
        this.levelScripte.reNewTiTles(0);
        this.levelScripte.reNewTiTles2(0);

        this.levelScripte.openBlock();
        let black = this.maskNode.getChildByName("black");
        let targetLabel: cc.Node = black.getChildByName("label4");
        black.opacity = 255;

        // this.qiaoClick.active = true;
        // this.ren1ZouEffect();
        // this.levelScripte.closeBlock();

        targetLabel.active = true;
        cc.tween(black)
            .delay(1)
            .call(() => {
                let deleteTime = 1;
                for (let i = 0; i < targetLabel.childrenCount; i++) {
                    let nodes = targetLabel.children[i];
                    cc.tween(nodes)
                        .delay(deleteTime * (i + 1))
                        .to(0.5, { opacity: 255 })
                        .start();
                }
                cc.tween(this.node)
                    .delay(deleteTime * (targetLabel.childrenCount + 1) + 1)
                    .call(() => {
                        targetLabel.active = false;
                        cc.tween(black)
                            .to(0.5, { opacity: 0 })
                            .delay(0.5)
                            .call(() => {
                                // this.stageEffect();
                                this.qiaoClick.active = true;
                                this.ren1ZouEffect();
                                this.levelScripte.closeBlock();
                            })
                            .start();
                    })
                    .start();
            })
            .start();

        let winClick = this.gameNode.getChildByName("winClick");
        winClick.on(cc.Node.EventType.TOUCH_START, ((e: cc.Event.EventTouch) => {
            cc.tween(winClick)
                .delay(1)
                .call(() => {
                    this.winClick();
                })
                .start();
        })).bind(this);
        winClick.on(cc.Node.EventType.TOUCH_MOVE, ((e: cc.Event.EventTouch) => {
            let startPos = e.getStartLocation();
            let curPos = e.getLocation();
            if (curPos.sub(startPos).len() > 10) {
                winClick.stopAllActions();
            }
        })).bind(this);
        winClick.on(cc.Node.EventType.TOUCH_END, ((e: cc.Event.EventTouch) => {
            winClick.stopAllActions();
        })).bind(this);

        let clickShouji = this.gameNode.getChildByName("clickShouji");
        clickShouji.on(cc.Node.EventType.TOUCH_END, ((e: cc.Event.EventTouch) => {
            e.stopPropagation();
            clickShouji.active = false;
            managers().soundMgr.playSound("sao", null, this.bundleName);
            this.levelScripte.openBlock();
            cc.tween(this.node)
                .delay(0.5)
                .call(() => {
                    managers().soundMgr.playSound("daozhang", null, this.bundleName);
                })
                .delay(2)
                .call(() => {
                    let ren3_4 = this.texie3Node.getChildByName("ren3_4");
                    let shou3 = this.texie3Node.getChildByName("shou3");
                    let movePos = ren3_4.position.add(cc.v3(0, 300));
                    cc.tween(ren3_4)
                        .to(0.5, { position: movePos })
                        .delay(0.5)
                        .call(() => {
                            cc.tween(shou3)
                                .to(0.5, { position: cc.v3(85, -78) })
                                .call(() => {
                                    this.answerNode[5].active = true;
                                    this.levelScripte.closeBlock();
                                })
                                .start();
                        })
                        .start();
                })
                .start();
        })).bind(this);

    }


    touchInfoCall(info: ViewAnswer012) {



        managers().soundMgr.stopAllEffects();

        let soundName = this.clickSoundList[info.index];
        managers().soundMgr.playSound(soundName, null, this.bundleName);
        this.showChat(this.showChatList[info.index]);

        info.node.getChildByName("quan").active = true;
        // info.node.children[1].active = true;

        const quan = info.node.getChildByName("quan");
        quan.active = true;
        quan.opacity = 255;
        cc.tween(quan)
            .delay(2)
            .to(0.5, { opacity: 0 })
            .call(() => {
                info.node.active = false;
            })
            .start();
        this.node.stopAllActions();
        if (this.curSayNode) {
            this.curSayNode.stopAllActions();
            this.curSayNode.active = false;
            this.curSayNode = null;
        }
        if (info.index == 0) {
            this.showChat("他没有脚，为什么会有脚步声？", 2)
            cc.tween(this.node)
                .delay(2.5)
                .call(() => {
                    this.checkWinOver();
                })
                .start();
        }
        else if (info.index == 1) {
            this.ren1Say("太清宫联名款，喜欢吗", 3.5);
            cc.tween(this.node)
                .delay(3.5)
                .call(() => {
                    this.checkWinOver();
                })
                .start();
        }
        else if (info.index == 2) {
            // this.showChat("他怎么只穿了一只鞋子", 2);
            let ren2 = this.gameNode.getChildByName("ren2");
            let ren2_2 = ren2.getChildByName("ren2-2");
            let jiao1 = this.texie2Node.getChildByName("jiao1");
            let newPos = ren2_2.position.add(cc.v3(0, 150));
            let texieNewPos = jiao1.position.add(cc.v3(-80, 300));
            cc.tween(ren2_2)
                .delay(0.5)
                .to(0.5, { position: newPos })
                .start();
            cc.tween(jiao1)
                .delay(0.5)
                .to(0.5, { position: texieNewPos, angle: 45 })
                .start();
            cc.tween(this.node)
                .delay(2.5)
                .call(() => {
                    managers().soundMgr.playSound("B3", null, this.bundleName);
                    // this.ren1Say("你看错了", 0.6);
                })
                .delay(1)
                .call(() => {
                    this.checkWinOver();
                })
                .start();
        }
        else if (info.index == 3) {
            managers().soundMgr.playSound("B2", null, this.bundleName);
            // this.ren1Say("我只有这种纸了", 1.2);
            cc.tween(this.node)
                .delay(1.2)
                .call(() => {
                    this.checkWinOver();
                })
                .start();
        }
        else if (info.index == 4) {
            // managers().soundMgr.playSound("lv10012/sound/B2");
            this.levelScripte.openBlock();
            let ren3_3 = this.texie3Node.getChildByName("ren3_3");
            let ren3_4 = this.texie3Node.getChildByName("ren3_4");
            let newPos4 = ren3_4.position.add(cc.v3(0, -300));
            let newPos3 = ren3_3.position.add(cc.v3(0, 300));
            let hei = ren3_4.getChildByName("hei");
            cc.tween(hei)
                .to(0.5, { opacity: 0 })
                .call(() => {

                })
                .start();
            // this.ren1Say("我真的没有偷拍你", 2);
            cc.tween(this.node)
                // .delay(2)
                // .call(() => {
                //     managers().soundMgr.playSound("lv10012/sound/PB2");
                //     this.showChat("没关系，可以借我一些纸吗？", 2);
                // })
                .delay(1)
                .call(() => {
                    cc.tween(ren3_4)
                        // .to(0.5, { position: newPos4 })
                        .call(() => {
                            managers().soundMgr.playSound("C4", null, this.bundleName);
                            this.ren3Say("V我50", 1);
                            let clickShouji = this.gameNode.getChildByName("clickShouji");
                            clickShouji.active = true;
                            this.levelScripte.closeBlock();
                        })
                        .start();
                })
                .start();
        }
        else if (info.index == 5) {
            // managers().soundMgr.playSound("lv10012/sound/B2");
            this.ren1Say("没有多余的纸了，要不你试试这个？", 2.5);
            cc.tween(this.node)
                .delay(2.5)
                .call(() => {
                    this.checkWinOver();
                })
                .start();
        }

        // this.scheduleOnce(() => {
        this.compeleteInfo(info);
        // }, 0.5)
    }
    loadAnswerImg(url: string, img: cc.Sprite) {
        // return

        const bundle = cc.assetManager.getBundle(this.bundleName);
        bundle.load(this.imgListUrl + url, cc.Texture2D, (e, ass: cc.Texture2D) => {
            if (e) {
                console.warn("没有图片", e)
                return
            }
            const frame = new cc.SpriteFrame(ass);
            img.spriteFrame = frame;
        })
    }

    deleteTime: number[] = [4, 2];

    /**完成一个 */
    async compeleteInfo(info: ViewAnswer012) {
        let willInfo: ViewAnswer012 = null
        for (let i = 0; i < this.windowAnswerInfo.length; i++) {
            const checkInfo = this.windowAnswerInfo[i];
            if (checkInfo.compelete || willInfo != null) {
                continue
            }
            willInfo = checkInfo;
        }
        this.canClick = false;
        info.compelete = true;
        willInfo.compelete = true;
        this.curBingoNum++;
        managers().soundMgr.playSound("hcy1");
        willInfo.node.getChildByName("name").getComponent(cc.Label).fontSize = 25;
        willInfo.node.getChildByName("name").getComponent(cc.Label).string = this.showStr[info.index];
        this.loadAnswerImg(info.img, willInfo.node.getChildByName('img').getComponent(cc.Sprite));
        this.canClick = true;
    }

    stageList: number[] = [];

    checkWinOver() {
        if (this.curStage == 0 && this.stageList[this.curStage] == this.curBingoNum) {
            this.curBingoNum = 0;
            this.qiaoClick.active = true;
            this.endClick.active = true;
            this.windowParent.children.forEach((obj) => {
                obj.active = false;
            })
            this.showTeXieBtn();
        }
        if (this.curStage == 1 && this.stageList[this.curStage] == this.curBingoNum) {
            this.curBingoNum = 0;
            this.qiaoClick.active = true;
            this.endClick.active = true;
            this.windowParent.children.forEach((obj) => {
                obj.active = false;
            })
            this.showTeXieBtn();
        }
        if (this.curStage == 2 && this.stageList[this.curStage] == this.curBingoNum) {
            this.curBingoNum = 0;
            console.info("弹出选项");
            this.levelScripte.openBlock();
            let winClick = this.gameNode.getChildByName("winClick");
            winClick.active = true;
            this.qiaoClick.active = true;
            this.endClick.active = true;
            this.endClick.opacity = 0;
            this.windowParent.active = false;
            cc.tween(this.endClick)
                .to(0.5, { opacity: 255 })
                .call(() => {
                    this.levelScripte.closeBlock();
                })
                .start();
            this.showTeXieBtn();
        }
    }

    reNewClickState() {
        // this.endClick.active = true;
        // this.qiaoClick.active = true;
        for (let i = 0; i < this.isCanNa.length; i++) {
            if (this.isCanNa[i]) {
                this.endClick.children[i].active = true;
                this.qiaoClick.children[i].active = false;
            }
            else {
                this.endClick.children[i].active = false;
                this.qiaoClick.children[i].active = true;
            }
        }
    }

    /**
        * 敲门效果 -- 传入节点 使这个节点循环显示和消失
        * @param targetNode 目标节点
        * @param loopNum 循环次数
        * @param stopTime 停留时间
        */
    qiaoMenEffect(targetNode: cc.Node, loopNum: number, stopTime: number) {
        targetNode.active = true;
        // targetNode.opacity = 0;
        // cc.tween(targetNode)
        //     .repeat(loopNum,
        //         cc.tween(targetNode)
        //             .delay(stopTime)
        //             .call(() => {
        //                 targetNode.opacity = 255;
        //             })
        //             .delay(0.15)
        //             .call(() => {
        //                 targetNode.opacity = 0;
        //             })
        //             .start()
        //     )
        //     .start();
        cc.tween(targetNode)
            .delay(1)
            .call(() => {
                targetNode.active = false;
            })
            .start();
    }

    ren1Say(content: string, time: number, call?: Function) {

        if (this.curSayNode) {
            this.curSayNode.stopAllActions();
            this.curSayNode.active = false;
            this.curSayNode = null;
        }
        this.curSayNode = this.ren1SayNode;
        let label = this.ren1SayNode.getComponentInChildren(cc.Label);
        label.string = "" + content;
        this.ren1SayNode.opacity = 255;
        this.ren1SayNode.active = true;
        cc.tween(this.ren1SayNode)
            .delay(time)
            .to(0.5, { opacity: 0 })
            .call(() => {
                call && call();
            })
            .start();
    }
    // ren1Say(content: string, time: number, call?: Function) {

    //     if (this.curSayNode) {
    //         this.curSayNode.stopAllActions();
    //         this.curSayNode.active = false;
    //         this.curSayNode = null;
    //     }
    //     this.curSayNode = this.ren2SayNode;
    //     let label = this.ren2SayNode.getComponentInChildren(cc.Label);
    //     label.string = "" + content;
    //     this.ren2SayNode.opacity = 255;
    //     this.ren2SayNode.active = true;
    //     cc.tween(this.ren2SayNode)
    //         .delay(time)
    //         .to(0.5, { opacity: 0 })
    //         .call(() => {
    //             call && call();
    //         })
    //         .start();
    // }
    ren3Say(content: string, time: number, call?: Function) {

        if (this.curSayNode) {
            this.curSayNode.stopAllActions();
            this.curSayNode.active = false;
            this.curSayNode = null;
        }
        this.curSayNode = this.ren3SayNode;
        let label = this.ren3SayNode.getComponentInChildren(cc.Label);
        label.string = "" + content;
        this.ren3SayNode.opacity = 255;
        this.ren3SayNode.active = true;
        cc.tween(this.ren3SayNode)
            .delay(time)
            .to(0.5, { opacity: 0 })
            .call(() => {
                call && call();
            })
            .start();
    }
    ren4Say(content: string, time: number, call?: Function) {

        if (this.curSayNode) {
            this.curSayNode.stopAllActions();
            this.curSayNode.active = false;
            this.curSayNode = null;
        }
        this.curSayNode = this.ren4SayNode;
        let label = this.ren4SayNode.getComponentInChildren(cc.Label);
        label.string = "" + content;
        this.ren4SayNode.opacity = 255;
        this.ren4SayNode.active = true;
        cc.tween(this.ren4SayNode)
            .delay(time)
            .to(0.5, { opacity: 0 })
            .call(() => {
                call && call();
            })
            .start();
    }


    stageEffect(e, custom: string) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.qiaoClick.active = false;
        this.endClick.active = false;
        let tag = Number(custom);
        this.curStage++;
        this.isCanNa[tag] = true;
        let playShou = this.gameNode.getChildByName("playShou");
        playShou.active = false;
        if (tag == 0) {
            this.levelScripte.openBlock();
            let ren = this.gameNode.getChildByName("ren");
            let ren1 = this.gameNode.getChildByName("ren1");
            let dong1 = this.gameNode.getChildByName("dong1");
            // let shou = ren1.getChildByName("shou");
            let shou1 = this.texie1Node.getChildByName("shou1");
            let jiao1 = this.texie1Node.getChildByName("jiao1");


            let movePos = cc.v3(10, -20);



            managers().soundMgr.playSound("qiaomen", null, this.bundleName);
            this.qiaoMenEffect(dong1, 3, 0.3);
            cc.tween(this.node)
                .delay(2.2)
                .call(() => {
                    ren.stopAllActions();
                    ren.scaleX = ren.scaleX > 0 ? ren.scaleX : ren.scaleX * -1;
                    let times = 0.1;
                    cc.tween(ren)
                        .to(times, { position: movePos })
                        .call(() => {
                            ren.opacity = 0;
                            ren1.active = true;
                        })
                        .delay(1)
                        .call(() => {
                            this.stageList.push(2);
                            playShou.active = true;

                            cc.tween(this.node)
                                // .delay(2)
                                .call(() => {
                                    ren1.opacity = 255;
                                    this.texie1Node.active = true;
                                    this.levelScripte.reNewTiTles(1);
                                    ren1.getChildByName("ren1_zhan").active = false;
                                    ren1.getChildByName("ren").active = true;
                                })
                                .delay(1)
                                .call(() => {
                                    managers().soundMgr.playSound("A1", null, this.bundleName);
                                    this.ren1Say("有什么可以帮你的吗？", 2);
                                })
                                .delay(2.3)
                                .call(() => {
                                    managers().soundMgr.playSound("PB1", null, this.bundleName);
                                    this.showChat("我忘记带纸了，可以借我一些纸吗？", 2.2)
                                })
                                .delay(3)
                                .call(() => {
                                    let ren1_zhan = this.texie1Node.getChildByName("ren1_zhan");
                                    let ren1_1 = this.texie1Node.getChildByName("ren1-1");
                                    ren1_1.active = true;
                                    ren1_1.opacity = 0;
                                    cc.tween(ren1_zhan)
                                        .to(0.5, { opacity: 0 })
                                        .start();
                                    cc.tween(ren1_1)
                                        .to(0.5, { opacity: 255 })
                                        .start();
                                })
                                .delay(1)
                                .call(() => {
                                    shou1.active = true;
                                    cc.tween(shou1)
                                        .to(0.5, { position: cc.v3(-89.913, -45) })
                                        .call(() => {
                                            let wen = shou1.getChildByName("wen");
                                            cc.tween(wen)
                                                .repeatForever(
                                                    cc.tween(wen)
                                                        .to(1, { opacity: 255 })
                                                        .delay(0.5)
                                                        .to(1, { opacity: 0 })
                                                        .start()
                                                )
                                                .start();
                                            for (let i = 0; i < this.answerNode.length; i++) {
                                                if (i < 2) {
                                                    this.answerNode[i].active = true;
                                                }
                                                else {
                                                    this.answerNode[i].active = false;
                                                }
                                            }
                                            this.reNewDaan();
                                            this.levelScripte.closeBlock();

                                        })
                                        .start();
                                })
                                .start();
                        })
                        .start();
                })
                .start();

        }
        else if (tag == 1) {
            this.levelScripte.openBlock();
            this.isPlayZouSound = false;
            let ren2 = this.gameNode.getChildByName("ren2");
            let ren2_2 = ren2.getChildByName("ren2-2");
            let dong2 = this.gameNode.getChildByName("dong2");
            let shou = ren2.getChildByName("shou");
            let shou2 = this.texie2Node.getChildByName("shou2");
            this.stageList.push(2);

            ren2.active = true;
            // ren2.opacity = 0;
            cc.tween(ren2)
                .delay(0.5)
                .call(() => {
                    managers().soundMgr.playSound("qiaomen", null, this.bundleName);
                    this.qiaoMenEffect(dong2, 3, 0.3);
                })
                .start();
            cc.tween(this.node)
                .delay(2.5)
                .call(() => {
                    shou.active = true;
                    this.texie2Node.active = true;
                    this.levelScripte.reNewTiTles(1);
                })
                .delay(1)
                .call(() => {
                    managers().soundMgr.playSound("PB3", null, this.bundleName);
                    this.showChat("可以借我一些纸吗？", 1)

                })
                .delay(1)
                .call(() => {
                    managers().soundMgr.playSound("B1", null, this.bundleName);
                })
                // .delay(0.5)
                .call(() => {
                    this.ren1Say("可以啊，你等等", 2);
                })
                .delay(2)
                .call(() => {
                    shou2.active = true;
                    cc.tween(shou2)
                        .to(0.5, { position: cc.v3(67.911, -102.66) })
                        .call(() => {
                            for (let i = 0; i < this.answerNode.length; i++) {
                                if (i >= 2 && i < 4) {
                                    this.answerNode[i].active = true;
                                }
                                else {
                                    this.answerNode[i].active = false;
                                }
                            }
                            this.reNewDaan();
                            playShou.active = true;
                            this.levelScripte.closeBlock();
                        })
                        .start();
                })
                .start();

        }
        else if (tag == 2) {
            this.levelScripte.openBlock();
            this.isPlayZouSound = false;
            let ren3 = this.gameNode.getChildByName("ren3");
            let dong3 = this.gameNode.getChildByName("dong3");
            let shou = ren3.getChildByName("shou");
            let shou3 = this.texie3Node.getChildByName("shou3");
            this.stageList.push(2);

            cc.tween(ren3)
                .delay(0.5)
                .call(() => {
                    managers().soundMgr.playSound("qiaomen", null, this.bundleName);
                    this.qiaoMenEffect(dong3, 3, 0.3);
                })
                .start();
            cc.tween(this.node)
                .delay(2)
                .call(() => {
                    this.texie3Node.active = true;
                    this.levelScripte.reNewTiTles(1);
                    shou.active = true;
                })
                .delay(1)
                .call(() => {
                    managers().soundMgr.playSound("C1", null, this.bundleName);
                    this.ren1Say("对不起，我走错了", 2.2);
                })
                .delay(2.2)
                .call(() => {
                    for (let i = 0; i < this.answerNode.length; i++) {
                        if (i >= 4) {
                            this.answerNode[i].active = true;
                        }
                        else {
                            this.answerNode[i].active = false;
                        }
                    }
                    this.answerNode[5].active = false;
                    this.reNewDaan();
                    playShou.active = true;
                    this.levelScripte.closeBlock();
                })
                .start();
        }
        this.reNewClickState();
    }

    reNewDaan() {
        if (this.curStage == 0) {
            for (let i = 0; i < this.windowParent.childrenCount; i++) {
                if (i < this.stageList[0]) {
                    this.windowParent.children[i].active = true;
                }
                else {
                    this.windowParent.children[i].active = false;
                }
            }
        }
        else if (this.curStage == 1) {
            for (let i = 0; i < this.windowParent.childrenCount; i++) {
                if (i >= this.stageList[0] && i < (this.stageList[0] + this.stageList[1])) {
                    this.windowParent.children[i].active = true;
                }
                else {
                    this.windowParent.children[i].active = false;
                }
            }
        }
        else if (this.curStage == 2) {
            for (let i = 0; i < this.windowParent.childrenCount; i++) {
                if (i >= (this.stageList[0] + this.stageList[1])) {
                    this.windowParent.children[i].active = true;
                }
                else {
                    this.windowParent.children[i].active = false;
                }
            }
        }
    }

    winClick() {
        this.levelScripte.openBlock();
        managers().soundMgr.playSound("hcy1");
        cc.tween(this.node)
            .delay(0.5)
            .call(() => {
                let lastClick = this.gameNode.getChildByName("lastClick");
                let winClick = this.gameNode.getChildByName("winClick");
                winClick.active = false;
                this.endClick.active = false;
                lastClick.active = false;
                let playShou = this.gameNode.getChildByName("playShou");
                let playShou2 = this.gameNode.getChildByName("playShou2");
                let black = this.maskNode.getChildByName("black");
                let winE = this.maskNode.getChildByName("winE");
                playShou.active = false;
                playShou2.active = true;

                managers().soundMgr.playSound("PB6", null, this.bundleName);
                this.ren4Say("可恶啊，只能靠自己了吗", 2);
                cc.tween(playShou2)
                    .to(0.5, { position: cc.v3(14.458, -243.93) })
                    .delay(1.5)
                    .call(() => {
                        cc.tween(black)
                            .to(0.5, { opacity: 255 })
                            .delay(0.5)
                            .call(() => {
                                winE.active = true;
                                winE.opacity = 0;
                                cc.tween(winE)
                                    .to(0.5, { opacity: 255 })
                                    .call(() => {
                                        managers().soundMgr.playSound("xishou", null, this.bundleName);
                                    })
                                    .delay(2)
                                    .call(() => {
                                        this.levelScripte.Win(0.1);
                                    })
                                    .start();
                            })
                            .start();
                    })
                    .start();


            })
            .start();
    }

    /** 转账按钮 */
    zhuanBtn() {
        this.levelScripte.openBlock();
        let ren1 = this.gameNode.getChildByName("ren1");
        let ren2 = this.gameNode.getChildByName("ren2");
        let ren3 = this.gameNode.getChildByName("ren3");
        let lastClick = this.gameNode.getChildByName("lastClick");
        lastClick.active = false;
        managers().soundMgr.playSound("anNiu");
        cc.tween(this.node)
            .call(() => {
                managers().soundMgr.playSound("daozhang", null, this.bundleName);
            })
            .delay(2.7)
            .call(() => {
                managers().soundMgr.playSound("C5", null, this.bundleName);
                this.ren3Say("兄弟们，撤退!", 1.2);
            })
            .delay(1.8)
            .call(() => {
                managers().soundMgr.playSound("endPao", null, this.bundleName);
                cc.tween(ren1)
                    .to(0.2, { opacity: 0 })
                    .start();
                cc.tween(ren2)
                    .to(0.2, { opacity: 0 })
                    .start();
                cc.tween(ren3)
                    .to(0.2, { opacity: 0 })
                    .start();
            })
            .delay(0.5)
            .call(() => {
                let black = this.maskNode.getChildByName("black");
                cc.tween(black)
                    .to(0.5, { opacity: 255 })
                    .delay(0.5)
                    .call(() => {
                        managers().soundMgr.playSound("xishou", null, this.bundleName);
                    })
                    .delay(3)
                    .call(() => {
                        this.levelScripte.Win(0.1);
                    })
                    .start();
            })
            .start();

    }

    /** 不转账按钮 */
    nozhuanBtn() {
        managers().soundMgr.playSound("anNiu");
        let lastClick = this.gameNode.getChildByName("lastClick");
        let winClick = this.gameNode.getChildByName("winClick");
        winClick.active = true;

        lastClick.active = false;
        this.endClick.active = true;

    }

    selectZhi(e, custom: string) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.levelScripte.openBlock();
        this.endClick.active = false;
        let tag = Number(custom);
        let black = this.maskNode.getChildByName("black");
        let label1 = black.getChildByName("label1");
        let label2 = black.getChildByName("label2");
        let label3 = black.getChildByName("label3");
        let targetLabel: cc.Node = null;
        black.opacity = 0;
        if (tag == 0) {
            targetLabel = label1;
        }
        else if (tag == 1) {
            targetLabel = label2;
        }
        else if (tag == 2) {
            targetLabel = label3;
        }
        targetLabel.active = true;
        targetLabel.opacity = 0;
        cc.tween(black)
            .delay(1)
            .to(0.5, { opacity: 255 })
            .call(() => {
                cc.tween(targetLabel)
                    .delay(0.5)
                    .call(() => {
                        if (tag == 2) {
                            managers().soundMgr.playSound("shazhi", null, this.bundleName);
                        }
                    })
                    .to(1, { opacity: 255 })
                    .call(() => {
                        if (tag == 0) {
                            managers().soundMgr.playSound("selectZhi1", null, this.bundleName);
                        }
                        else if (tag == 1) {
                            managers().soundMgr.playSound("selectZhi2", null, this.bundleName);
                        }
                        let deleteTime = 1;
                        for (let i = 0; i < targetLabel.childrenCount; i++) {
                            let nodes = targetLabel.children[i];
                            cc.tween(nodes)
                                .delay(deleteTime * (i + 1))
                                .to(0.5, { opacity: 255 })
                                .start();
                        }
                        cc.tween(this.node)
                            .delay(deleteTime * (targetLabel.childrenCount + 1))
                            .call(() => {
                                this.levelScripte.Lose();
                            })
                            .start();
                    })
                    .start();

            })
            .start();

    }

    /** 显示特写界面的按钮 */
    showTeXieBtn() {
        if (this.texie1Node.active) {
            let ren1 = this.gameNode.getChildByName("ren1");
            this.texie1Node.getChildByName("btn").active = true;
            // ren1.getChildByName("shaqi").active = true;
            // this.texie1Node.getChildByName("shaqi").active = true;
        }
        else if (this.texie2Node.active) {
            this.texie2Node.getChildByName("btn").active = true;
        }
        else if (this.texie3Node.active) {
            this.texie3Node.getChildByName("btn").active = true;
        }
    }

    teXieNoBtn(e, custom: string) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let tag = Number(custom);
        if (tag == 0) {
            this.texie1Node.active = false;
        }
        else if (tag == 1) {
            this.texie2Node.active = false;
            this.isPlayZouSound = true;
        }
        else if (tag == 2) {
            this.texie3Node.active = false;
            this.isPlayZouSound = true;
        }
        this.levelScripte.reNewTiTles(0);
    }

    ren1ZouEffect() {
        // 外面的人走
        let ren = this.gameNode.getChildByName("ren");
        let oldPos = cc.v3(-550, ren.y, 0);
        let newPos = cc.v3(550, ren.y, 0);
        let jiaobuTime: number = 0.9;
        cc.tween(ren)
            .repeatForever(
                cc.tween(ren)
                    .call(() => {
                        ren.scaleX = ren.scaleX > 0 ? ren.scaleX * -1 : ren.scaleX;
                        for (let i = 0; i < 6; i++) {
                            cc.tween(ren)
                                .delay(jiaobuTime * i)
                                .call(() => {
                                    if (this.isPlayZouSound)
                                        managers().soundMgr.playSound("jiaobu", null, this.bundleName);
                                })
                                .start();
                        }
                    })
                    .to(5, { position: newPos })
                    .delay(1)
                    .call(() => {
                        ren.scaleX = ren.scaleX > 0 ? ren.scaleX : ren.scaleX * -1;
                        for (let i = 0; i < 6; i++) {
                            cc.tween(ren)
                                .delay(jiaobuTime * i)
                                .call(() => {
                                    if (this.isPlayZouSound)
                                        managers().soundMgr.playSound("jiaobu", null, this.bundleName);
                                })
                                .start();
                        }
                    })
                    .to(5, { position: oldPos })
                    .delay(1)
                    .start()
            )
            .start();
    }

    update(dt) {

    }
}
